<template>
    <!-- <div v-if="loadedFromServer == false">
        loading
    </div> -->
    <div v-if="loadedFromServer" class="">





        <v-dialog absolute class="bottom dialog-bx" height="700px" width="800px" v-model="questionDialog">
            <v-card height="700px" color="background">
                <v-card-text class="pa-8 ">
                    <v-row justify="space-between" class="t-h5 px-3">
                        <v-col class="ml-0m pl-0">

                            Your Responses
                        </v-col>
                        <v-col class="text-right">
                            <v-icon @click="questionDialog = false">
                                mdi-close
                            </v-icon>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-divider class=" mt-2 mb-5">

                        </v-divider>
                    </v-row> <v-row>

                        <v-col cols="auto" class="">
                            <v-avatar size="40" variant="outlined" class="mr-2 correct ">
                                {{ testInstanceQuestionSummary.correctQuestions }}
                            </v-avatar><span>
                                Correct
                            </span>
                        </v-col>
                        <v-col cols="auto" class="">
                            <v-avatar size="40" variant="outlined" class="mr-2 incorrect">
                                {{ testInstanceQuestionSummary.incorrectQuestions }}

                            </v-avatar><span>
                                Incorrect
                            </span>
                        </v-col><v-col cols="auto" class="">
                            <v-avatar size="40" variant="outlined" class="mr-2 unattempted">
                                {{ testInstanceQuestionSummary.unattemptedQuestions }}

                            </v-avatar><span>
                                Not Attempted
                            </span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-divider class="my-5">

                        </v-divider>
                    </v-row>

                    <v-row class="my-4" v-for="item, sIndex in currentTestResultJson" :key="sIndex">
                        <v-col v-if="item.visibleOnApp" cols="12" class="t-h5Reg">
                            {{ item.sectionName }}
                        </v-col>

                        <v-row>

                            <v-col cols="auto" class="mx-2" v-for="item, qIndex in item.questions" :key="qIndex">

                                <v-avatar style="cursor: pointer;" @click="openQFromDialog(sIndex, qIndex)" size="40"
                                    variant="outlined" :class="{
                                        'unattempted': item.isCorrect == null,
                                        'correct': item.isCorrect != null && item.isCorrect == true,
                                        'incorrect': item.isCorrect != null && item.isCorrect == false,
                                    }">
                                    {{ qIndex + 1 }}

                                </v-avatar>

                            </v-col>
                        </v-row>
                    </v-row>

                </v-card-text>

            </v-card>
        </v-dialog>

        <v-app-bar color="navbar">

            <v-app-bar-title>
                <template v-slot:text>
                    <span class>
                        {{ testInstanceQuestionSummary.testName }}

                    </span>
                </template>

            </v-app-bar-title>


            <v-spacer></v-spacer>

            <v-icon @click="exitDialog = true" class="mr-4"> mdi-close</v-icon>

        </v-app-bar>
        <v-container fluid>
            <v-card elevation="0" class="pb-14">

                <v-row justify="center">
                    <v-dialog v-model="exitDialog" width="auto">

                        <v-card>
                            <v-card-title class="t-h5 text-capitalize">
                                Confirm
                                <v-divider class="mt-3">

                                </v-divider>
                            </v-card-title>
                            <v-card-text class="mb-3">Are you sure you want to leave the test review sceen</v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" variant="text" @click="exitDialog = false">
                                    No
                                </v-btn>
                                <v-btn color="primary" variant="text" @click="backFromDialog()">
                                    Yes
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
                <section class=" mx-5 mt-10">
                    <div class="mb-8">
                        <v-row class="align-center">
                            <span class="mx-3 qNoClass">
                                Question {{ currentQNo }}
                            </span>
                            <span class="text-green bx-big">
                                Marks obtained 
                                <div class="marks-obtained">
                                    {{currentQ.marks}} / {{ currentQ.totalQuestionMarks }}
                                </div>
                            </span>
                            <span v-if="currentQ.isBonus" class="text-green bx-big-bonus">
                                ✨ Bonus Marks 
                            </span>
                        </v-row>

                    </div>
                    <section>

                        <div>

                            <HtmlRender :htmlString="currentQ.qText
                                " class="htmlClassTest"></HtmlRender>
                        </div>
                    </section>


                    <div class="mt-15">


                        <v-row class="mt-4 mb-10 mx-1" v-if="currentQ.isCorrect == null">
                            <v-alert color="info" icon="$info" variant="tonal"
                                text="This question was not attempted"></v-alert>
                        </v-row>
                        <!-- case 1 -->
                        <section v-if="currentQ.qType == '1'">
                            <v-radio-group v-model="currentQ.userAnswerSingleChoice" readonly>

                                <v-row v-for="option in currentQ.options" :key="option.key">
                                    <v-col class="mb-0 pb-0" cols="12" v-if="userAnswerSingleChoice(currentQ, option.key)">

                                        <span v-if="correctAnswerSingleChoice(currentQ, option.key)" class="text-green">
                                            Your Answer - Correct
                                        </span>
                                        <span v-if="!correctAnswerSingleChoice(currentQ, option.key)" class="text-red">
                                            Your Answer - Incorrect
                                        </span>
                                    </v-col>
                                    <v-col class="mb-0 pb-0" cols="12"
                                        v-if="!userAnswerSingleChoice(currentQ, option.key) && correctAnswerSingleChoice(currentQ, option.key)">

                                        <span class="text-green">
                                            Correct Answer
                                        </span>

                                    </v-col>
                                    <v-col cols="12">
                                        <v-hover v-slot="{ isHovering, props }">

                                            <v-sheet class="bx" :class="{
                                                'on-hover': isHovering,
                                                'green-border': correctAnswerSingleChoice(currentQ, option.key),
                                                'red-border': !correctAnswerSingleChoice(currentQ, option.key) && userAnswerSingleChoice(currentQ, option.key)
                                            }" v-bind="props">

                                                <v-radio readonly density="compact" color="primary" class=" pa-2" dense
                                                    :value="option.key">
                                                    <template v-slot:label>
                                                        <HtmlRender class="htmlClassTest htmlClassTestOption ml-1"
                                                            :htmlString="option.value">
                                                        </HtmlRender>
                                                    </template>
                                                </v-radio>
                                            </v-sheet>
                                        </v-hover>
                                    </v-col>

                                </v-row>

                            </v-radio-group>
                        </section>


                        <section v-if="currentQ.qType == '2'">

                            <v-row v-for="option in currentQ.options" :key="option.key">
                                <v-col class="mb-0 pb-0" cols="12" v-if="userAnswerMultipleChoice(currentQ, option.key)">

                                    <span v-if="correctAnswerMultiChoice(currentQ, option.key)" class="text-green">
                                        Your Answer - Correct
                                    </span>
                                    <span v-if="!correctAnswerMultiChoice(currentQ, option.key)" class="text-red">
                                        Your Answer - Incorrect
                                    </span>
                                </v-col>
                                <v-col class="mb-0 pb-0" cols="12"
                                    v-if="!userAnswerMultipleChoice(currentQ, option.key) && correctAnswerMultiChoice(currentQ, option.key)">

                                    <span class="text-green">
                                        Correct Answer
                                    </span>

                                </v-col>
                                <v-col cols="12">
                                    <v-hover v-slot="{ isHovering, props }">

                                        <v-sheet v-bind="props" class="bx pa-0 ma-0" :class="{
                                            'on-hover': isHovering,
                                            'green-border': correctAnswerMultiChoice(currentQ, option.key),
                                            'red-border': !correctAnswerMultiChoice(currentQ, option.key) && userAnswerMultipleChoice(currentQ, option.key)
                                        }">
                                            <v-checkbox density="compact" hide-details v-model="currentQ.userAnswers"
                                                readonly color="primary" class="pa-2 testOption" :value="option.key">

                                                <template v-slot:label>

                                                    <HtmlRender class="htmlClassTest htmlClassTestOption ml-1"
                                                        :htmlString="option.value">
                                                    </HtmlRender>

                                                </template>
                                            </v-checkbox>
                                        </v-sheet>
                                    </v-hover>
                                </v-col>

                            </v-row>

                        </section>

                        <section v-if="currentQ.qType == '3'">

                            <v-row>
                                <v-col class="mb-0 pb-0" cols="12">
                                    <span v-if="currentQ.isCorrect != null">

                                        <span v-if="currentQ.isCorrect" class="text-green">
                                            Your Answer - Correct
                                        </span>
                                        <span v-if="!currentQ.isCorrect" class="text-red">
                                            Your Answer - Incorrect
                                        </span>
                                    </span>

                                </v-col>
                                <v-col v-if="currentQ.isCorrect != null" cols="8" md="3" lg="2">
                                    <v-text-field @click.prevent="" readonly v-model="currentQ.userAnswerInteger"
                                        label="Your Answer" variant="outlined" :color="currentQ.isCorrect ? 'green' : 'red'"
                                        focused></v-text-field>

                                </v-col>

                            </v-row>

                            <v-row v-if="currentQ.isCorrect == null || !currentQ.isCorrect">
                                <v-col class="mb-0 pb-0 text-green" cols="12">
                                    <span>
                                        Correct Answer
                                    </span>
                                </v-col>
                                <v-col cols="8" md="3" lg="2">
                                    <v-text-field readonly v-model="currentQ.answerInteger" label="Answer"
                                        variant="outlined" color="green" focused base-color="green"></v-text-field>

                                </v-col>
                            </v-row>

                        </section>

                        <section v-if="currentQ.qType == '4'">

                            <v-row>
                                <v-col class="mb-0 pb-0" cols="12">
                                    <span v-if="currentQ.isCorrect != null">
                                        <span v-if="currentQ.isCorrect" class="text-green">
                                            Your Answer - Correct
                                        </span>
                                        <span v-if="!currentQ.isCorrect" class="text-red">
                                            Your Answer - Incorrect
                                        </span>
                                    </span>

                                </v-col>
                                <v-col v-if="currentQ.isCorrect != null" cols="8" md="3" lg="2">
                                    <v-text-field readonly label="Answer" v-model="currentQ.userAnswerDecimal"
                                        :color="currentQ.isCorrect ? 'green' : 'red'" focused
                                        variant="outlined"></v-text-field>

                                </v-col>

                            </v-row>

                            <v-row>
                                <v-col class="mb-0 pb-0 text-green" cols="12">
                                    <span>
                                        Correct Answer
                                    </span>
                                </v-col>
                                <v-col cols="8" md="3" lg="2">
                                    <v-text-field readonly v-model="correctAnswerDecimal" label="Answer" variant="outlined"
                                        color="green" focused></v-text-field>

                                </v-col>
                            </v-row>

                        </section>
                    </div>



                </section>



                <section class="mx-4" v-if="currentQ.solution != null">
                    <v-row class="t-h5Reg mt-4">
                        <v-col cols="12">
                            Solution
                        </v-col>

                    </v-row>
                    <v-row>

                        <div>
                            <v-col cols="12">

                                <HtmlRender :htmlString="currentQ.solution
                                    " class="htmlClassTest"></HtmlRender>
                            </v-col>

                        </div>
                    </v-row>

                </section>
            </v-card>
        </v-container>

    </div>

    <v-footer v-if="loadedFromServer" app class="bg-background py-3">
        <v-row justify="space-between" class=" footer-row px-5 align-center">

            <v-col class="align-center">
                <v-btn size="large" v-if="$vuetify.display.mdAndUp" class="t-btn text-capitalize btn-rd"
                    :disabled="prevButtonDisabled" width="130" @click="prevQuestion" elevation="0"
                    :color="!prevButtonDisabled ? 'secondaryBackground' : undefined">
                    Previous
                    <template v-slot:prepend>
                        <v-icon>mdi-chevron-left</v-icon>
                    </template>
                </v-btn>

                <v-btn v-else density="compact" size="large" icon="mdi-chevron-left" :disabled="prevButtonDisabled"
                    @click="prevQuestion">
                </v-btn>

            </v-col>



            <v-col cols="auto">
                <v-btn @click="questionDialog = true" color="secondaryBackground" density="compact" elevation="0"
                    size="large" :icon="questionDialog == true ? 'mdi-chevron-down' : 'mdi-chevron-up'"></v-btn>
                <span class="ml-2">
                    {{ currentQNo }} of {{
                        currentTestResultJson[currentTestState.sectionIndex].questions.length }}
                </span>
            </v-col>

            <v-col class="text-end  align-center">
                <v-btn v-if="$vuetify.display.mdAndUp" size="large" width="130" class=" t-btn text-capitalize btn-rd"
                    elevation="0" @click="nextQuestion" color="primary">
                    Next
                    <template v-slot:append>
                        <v-icon color="white">mdi-chevron-right</v-icon>
                    </template>
                </v-btn>
                <v-btn v-else density="compact" size="large" icon="mdi-chevron-right" @click="nextQuestion" color="primary">
                </v-btn>
            </v-col>
        </v-row>
    </v-footer>
</template>
      
<script>
import { mapState } from "vuex";
// import _ from "lodash";
import HtmlRender from "@/components/Test/HtmlRender.vue";
import { AnalyticsEvents, recordAnalyticsEvent } from "@/services/awsPinpointAnalyticsService";

const marked = require("marked");

const renderer = new marked.Renderer();
renderer.link = function link(href, title, text) {
    return `<a href="${href}" title="${title}" target="_blank">${text}</a>`;
};
export default {
    name: 'TestResultPage',
    data: () => ({
        questionDialog: false,
        loadedFromServer: false,
        exitDialog: false
    }),
    components:
    {
        HtmlRender
    },
    async created() {


        this.$store.commit('appbarVisible', false);
        this.$store.commit('navbarVisible', false);
        if ('testId' in this.$route.params) {
            const test = this.$route.params.testId
            const instance = this.$route.query.instance
            recordAnalyticsEvent(AnalyticsEvents.v2TestInstanceViewSolutionsOpen, { testId: test, testInstanceId: instance });

            // console.log(this.$route);
            this.$store.commit('updateCurrentTestState', {
                sectionIndex: 0,
                qIndex: 0
            })
            this.$store.commit('clearTestResult')
            this.$store.commit('testResultLoadedFromServer', false)
            this.$store.dispatch("loadTestResult", { testId: test, instance: instance }).then(() => {
                this.loadedFromServer = true

                setTimeout(() => {
                    window.MathJax.typesetPromise();

                }, 10);

            })
        }
    },
    computed: {
        ...mapState(["currentTestResult", "currentTestResultJson", "currentTestState"]),
        testInstanceQuestionSummary: {
            get() {
                return this.currentTestResult.testInstanceQuestionSummary
            }
        },
        currentQNo: {
            get() {
                return this.currentTestState.qIndex + 1
            }
        },
        currentQ: {
            get() {
                if (this.currentTestResultJson.length == 0) {
                    return []
                }
                return this.currentTestResultJson[this.currentTestState.sectionIndex].questions[this.currentTestState.qIndex]
            }
        },
        currentSection: {
            get() {
                return this.currentTestResultJson[this.currentTestState.sectionIndex]
            }
        },
        prevButtonDisabled: {
            get() {
                return this.currentTestState.qIndex == 0 && this.currentTestState.sectionIndex == 0 ? true : false
            }
        },
        correctAnswerDecimal: {
            get() {
                return `${this.currentQ.answerDecimalLow} - ${this.currentQ.answerDecimalHigh}`
            }
        },
    },

    watch: {

    },

    methods: {
        correctAnswerSingleChoice(item, key) {
            if (item.answerSingleChoice == null) {
                return false
            }
            if (item.answerSingleChoice == key) {
                return true
            }
            return false
        },
        userAnswerSingleChoice(item, key) {
            if (item.userAnswerSingleChoice == null) {
                return false
            }
            if (item.userAnswerSingleChoice == key) {
                return true
            }
            return false
        },
        correctAnswerMultiChoice(item, key) {

            if (item.answers == null) {
                return false
            }
            if (item.answers.includes(key)) {
                return true
            }
            return false
        },
        userAnswerMultipleChoice(item, key) {
            if (item.userAnswers == null) {
                return false
            }
            if (item.userAnswers.includes(key)) {
                return true
            }
            return false
        },

        openQFromDialog(sIndex, qIndex) {
            this.$store.commit('updateCurrentTestState', {
                qIndex: qIndex,
                sectionIndex: sIndex
            })

            this.questionDialog = false

            setTimeout(() => {
                window.MathJax.typesetPromise();

            }, 10)
        },
        getMarkDownHtml(markdown) {
            if (markdown == null) {
                return ""
            }
            let markDownText = markdown
            let out = false;
            const regex = /\\/gm;
            const escapedString = markDownText.replace(regex, "\\\\");

            out = marked.parseInline(escapedString, { renderer });

            return out;
        },
        nextQuestion() {

            
            if (this.currentTestState.qIndex == this.currentTestResultJson[this.currentTestState.sectionIndex].questions.length - 1) {

                if (this.currentTestState.sectionIndex == this.currentTestResultJson.length - 1) {
                    // console.log("review");
                    // this.reviewScreen = true
                    this.exitDialog = true
                }
                else {
                    this.$store.commit('updateCurrentTestState', {
                        qIndex: 0,
                        sectionIndex: this.currentTestState.sectionIndex + 1
                    })
                }
            }
            else {

                this.$store.commit('updateCurrentTestState', {
                    qIndex: this.currentTestState.qIndex + 1,
                    sectionIndex: this.currentTestState.sectionIndex
                })
            }


            setTimeout(() => {
                window.MathJax.typesetPromise();

            }, 10)
            
            console.log(this.currentQ);

        },
        prevQuestion() {

            
            if (this.currentTestState.qIndex == 0) {

                if (this.currentTestState.sectionIndex == 0) {
                    console.log("first section");
                }
                else {
                    this.$store.commit('updateCurrentTestState', {
                        qIndex: this.currentTestResultJson[this.currentTestState.sectionIndex - 1].questions.length - 1,
                        sectionIndex: this.currentTestState.sectionIndex - 1
                    })
                }
            }
            else {

                // changes ui to next question
                this.$store.commit('updateCurrentTestState', {
                    qIndex: this.currentTestState.qIndex - 1,
                    sectionIndex: this.currentTestState.sectionIndex
                })
            }

            setTimeout(() => {
                window.MathJax.typesetPromise();
                
            }, 10)
            
            console.log(this.currentQ);
            
        },
        backFromDialog() {
            this.exitDialog = false
            this.$router.back()

        }
    }

}
</script>
      
      <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.correct {
    background: #26B99AA6 !important;
    color: white !important;
    ;
}

.success {
    background: #26B99AA6 !important;

}

.timer-color {
    color: #26B99AA6 !important;
}

.unanswered {
    border: 2px solid #949494 !important;
}

.marked {
    border: 2.5px solid #FF894F !important;
}

.option {

    /* box-shadow: 0px 2px 8px rgba(112, 144, 240, 0.2) !important; */
    border-radius: 10px;
    border: 1px rgb(var(--v-theme-secondaryBackground)) solid;
}

.v-sheet.on-hover {
    cursor: pointer;
    /* border: 1px solid rgb(var(--v-theme-primary)); */
    border-color: transparent;
    background-color: white;
    box-shadow: 0px 2px 8px rgba(112, 144, 240, 0.2) !important;

}

.green-border {
    border: 2.5px solid green !important;
}

.red-border {
    border: 2.5px solid #ff8a80 !important;
}

.incorrect {
    background: #ff8a80 !important;
    color: white !important;
}

.unattempted {
    border: 2px solid #949494 !important;
}

.bx {
    background-color: rgb(var(--v-theme-navColor));
    border: 1px solid #E7E7E7;
    border-radius: 4px;
}
.bx-big{
    display: flex;
    align-items: center;
    background-color: rgb(var(--v-theme-navColor));
    border: 1px solid #E7E7E7;
    border-radius: 4px;
    height: 20px;
    padding: 20px;
    font-size: 18px;
    max-width: 300px;
    margin-right: 20px;
}
.marks-obtained{
    margin-left: 25px;
}
.bx-big-bonus{
    display: flex;
    align-items: center;
    background-color: rgb(var(--v-theme-navColor));
    border: 1px solid #e2ffe0;
    border-radius: 4px;
    height: 20px;
    padding: 20px;
    font-size: 18px;
    font-weight: 900;
}
.card-bg-color {
    background-color: rgb(var(--v-theme-navColor)) !important;
    border: 0.5px solid rgba(0, 0, 0, 0.15) !important;
    border-radius: 12px !important;

}

.outline-color {
    border-color: rgb(var(--v-theme-secondaryBackground)) !important;
    ;

}

.bottom {
    position: absolute !important;
    bottom: 10px !important;
}

.v-overlay__content {
    position: absolute !important;
    bottom: 10px !important;

}

.scroll {}

.dialog-bx {
    position: fixed !important;
}

.htmlClassTestOption span {
    top: 0 !important;
    vertical-align: middle;
}

.testOption .v-selection-control--inline {

    min-width: 100% !important;
}

.testOption .v-label {

    width: 100% !important;
}

.qNoClass {
    font-size: 0.875rem
}
</style>
      